<template>
  <div class="archived-conversation-details">
    <p class="archive-topic">
      {{ t('archive_chat_history', { date: formatDate(conversation.created) }) }}
    </p>
    <Message
      v-for="message in archivedMessages"
      :key="message.msgId"
      :type="getMessageType(message)"
      :message="message"
      :isIncoming="isIncoming(message)"
    />
    <div class="footer">
      <ChatButton
        :size="24"
        class="back-button"
        @click="goBackToConversation"
      >
        <Icon art="regular" name="arrow-left-long" />
      </ChatButton>
      <span class="back-text">{{ t('buttons_back') }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { formatDate } from '@/helpers/helpers'
import Message from './../Message'
import ChatButton from '../ChatButton'
import Icon from '../Icon'

export default {
  name: 'ArchivedConversationsDetails',
  components: {
    Message,
    ChatButton,
    Icon
  },
  props: {
    conversation: {
      type: Object,
      default: () => ({})
    }
  },

  setup () {
    const { $label: t } = useI36n()

    return { t }
  },

  data () {
    return {
      archivedMessages: null,
      user: {}
    }
  },
  created () {
    this.getUser()
    this.$chatApi.getArchivedConversationMessages(this.conversation.convId)
      .then((result) => {
        this.archivedMessages = result
          .filter(message => !message?.aiaibotPayload?.buttons)
      })
  },
  computed: {
    ...mapGetters('uistate', ['webView'])
  },
  methods: {
    ...mapActions('conversation', ['setSelectedArchived']),
    ...mapActions('uistate', ['setArchiveView']),
    formatDate,
    getMessageType (message) {
      if (message.file) {
        return 'FILE'
      }
      return message.msgType
    },
    isIncoming (message) {
      if (message.dummy_user === true) {
        return false
      } else {
        return Number(message.senderId) !== Number(this.user.userId)
      }
    },
    getUser () {
      this.$chatApi.getUserInfo().then(user => {
        this.user = user
      })
    },
    goBackToConversation () {
      this.setSelectedArchived({})
      this.setArchiveView(false)
    }
  }
}
</script>

<style scoped lang="postcss">
.archived-conversation-details {
  max-height: 556px;
}
.archive-topic {
  padding: 15px;
  text-align: center;
  color: #999999;
  font-size: 12px;
}
.footer {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 10px 10px 10px 20px;
  min-height: 20px;
  background-color: #004435;
  .back-text {
    line-height: 2.1rem;
    padding-left: 5px;
    color: #fff;
  }
}
.back-button {
  padding: 0;
  background: transparent;
}
</style>
